// extracted by mini-css-extract-plugin
export var container = "_2j-0";